import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/hooks/useTheme";

export function ThemeToggle({ className = "", testId = "theme-toggle" }) {
  const { isDark, toggle } = useTheme();
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid={testId}
      aria-label={isDark ? "Switch to light" : "Switch to dark"}
      className={`inline-flex items-center justify-center w-10 h-10 rounded-full text-[var(--rm-text-muted)] hover:text-[var(--rm-text)] hover:bg-[var(--rm-bg-subtle)] transition-colors ${className}`}
    >
      {isDark ? <Sun size={18} strokeWidth={1.8} /> : <Moon size={18} strokeWidth={1.8} />}
    </button>
  );
}

export default ThemeToggle;
